import { MiTHEME } from "@miplatform/theme";
import { BUTTON_COLORS } from "../constants";
import {
  ATTEMPT_DERIVED_STATUS,
  ATTEMPT_STATUSES,
  SUBMIT_STATUSES,
  TASK_STATUSES,
} from "../statuses/statuses";

export const ATTEMPT_STATUS_COLORS = {
  [ATTEMPT_STATUSES.STARTED]: MiTHEME.palette.yellow.main,
  [SUBMIT_STATUSES.COMPLETE]: MiTHEME.palette.green.main,
  [SUBMIT_STATUSES.INCOMPLETE]: MiTHEME.palette.red.accent,
  [ATTEMPT_STATUSES.SUBMITTED]: MiTHEME.palette.green.main,
  [ATTEMPT_STATUSES.PLANNED]: MiTHEME.palette.blue.main,
  [ATTEMPT_STATUSES.NEW]: MiTHEME.palette.grey.main,
  [ATTEMPT_STATUSES.DISPATCHED]: MiTHEME.palette.red.accent,
  [ATTEMPT_STATUSES.HOLD]: MiTHEME.palette.purple.dark,
  [ATTEMPT_STATUSES.CLOSEOUT_IN_PROGRESS]: MiTHEME.palette.orange.dark,
  [ATTEMPT_STATUSES.CLOSED]: MiTHEME.palette.green.main,
};

export const ATTEMPT_STATUS_TITLE_COLORS = {
  [ATTEMPT_STATUSES.STARTED]: MiTHEME.palette.yellow.dark,
  [SUBMIT_STATUSES.COMPLETE]: MiTHEME.palette.green.dark,
  [SUBMIT_STATUSES.INCOMPLETE]: MiTHEME.palette.red.dark,
  [ATTEMPT_STATUSES.SUBMITTED]: MiTHEME.palette.green.main,
  [ATTEMPT_STATUSES.PLANNED]: MiTHEME.palette.blue.dark,
  [ATTEMPT_STATUSES.NEW]: MiTHEME.palette.grey.dark,
  [ATTEMPT_STATUSES.DISPATCHED]: MiTHEME.palette.red.dark,
  [ATTEMPT_STATUSES.HOLD]: MiTHEME.palette.deepPurple.darkAccent,
  [ATTEMPT_STATUSES.CLOSEOUT_IN_PROGRESS]: MiTHEME.palette.orange.dark,
  [ATTEMPT_STATUSES.CLOSED]: MiTHEME.palette.green.main,
};

export const ATTEMPT_STATUS_BUTTON_COLORS = {
  [ATTEMPT_STATUSES.STARTED]: BUTTON_COLORS.ORANGE,
  [SUBMIT_STATUSES.COMPLETE]: BUTTON_COLORS.PRIMARY,
  [SUBMIT_STATUSES.INCOMPLETE]: BUTTON_COLORS.RED,
  [ATTEMPT_STATUSES.PLANNED]: BUTTON_COLORS.BLUE,
  [ATTEMPT_STATUSES.NEW]: BUTTON_COLORS.GREY,
  [ATTEMPT_STATUSES.DISPATCHED]: BUTTON_COLORS.ORANGE,
};

export const TASK_STATUS_COLORS = {
  [TASK_STATUSES.IN_PROGRESS]: MiTHEME.palette.orange.dark,
  [SUBMIT_STATUSES.COMPLETE]: MiTHEME.palette.green.main,
  [SUBMIT_STATUSES.INCOMPLETE]: MiTHEME.palette.red.main,
  [TASK_STATUSES.NEW]: MiTHEME.palette.grey.darkAccent,
  [TASK_STATUSES.CANCELLED]: MiTHEME.palette.grey.darkAccent,
};

export const SUBMIT_STATUS_COLORS = {
  [SUBMIT_STATUSES.COMPLETE]: MiTHEME.palette.green.main,
  [SUBMIT_STATUSES.INCOMPLETE]: MiTHEME.palette.red.main,
};

export const ATTEMPT_DERIVED_STATUS_COLORS_MAP = {
  [ATTEMPT_DERIVED_STATUS.STARTED]: {
    main: MiTHEME.palette.yellow.main,
    title: MiTHEME.palette.caution.dark,
    statusBackground: `${MiTHEME.palette.yellow.main}2A`,
    background: `${MiTHEME.palette.yellow.main}1A`,
    cardBackground: MiTHEME.palette.yellow.light,
  },
  [ATTEMPT_DERIVED_STATUS.JOB_COMPLETE]: {
    main: MiTHEME.palette.green.main,
    title: MiTHEME.palette.green.dark,
    statusBackground: `${MiTHEME.palette.green.main}2A`,
    background: MiTHEME.palette.common.white,
    cardBackground: MiTHEME.palette.green.light,
  },
  [ATTEMPT_DERIVED_STATUS.JOB_INCOMPLETE]: {
    main: MiTHEME.palette.red.accent,
    title: MiTHEME.palette.red.dark,
    statusBackground: `${MiTHEME.palette.red.accent}2A`,
    background: MiTHEME.palette.common.white,
    cardBackground: MiTHEME.palette.red.light,
  },
  [ATTEMPT_DERIVED_STATUS.INVOICED]: {
    main: MiTHEME.palette.green.main,
    title: MiTHEME.palette.green.main,
    statusBackground: `${MiTHEME.palette.green.main}2A`,
    background: `${MiTHEME.palette.green.main}1A`,
    cardBackground: MiTHEME.palette.green.light,
  },
  [ATTEMPT_DERIVED_STATUS.SCHEDULED]: {
    main: MiTHEME.palette.blue.main,
    title: MiTHEME.palette.blue.dark,
    statusBackground: `${MiTHEME.palette.blue.main}2A`,
    background: `${MiTHEME.palette.blue.main}1A`,
    cardBorder: MiTHEME.palette.grey.darkerAccent,
  },
  [ATTEMPT_DERIVED_STATUS.NEW]: {
    main: MiTHEME.palette.grey.main,
    title: MiTHEME.palette.grey.dark,
    statusBackground: `${MiTHEME.palette.grey.main}2A`,
    background: `${MiTHEME.palette.grey.main}1A`,
  },
  [ATTEMPT_DERIVED_STATUS.ENROUTE]: {
    main: MiTHEME.palette.orange.darkAccent,
    title: MiTHEME.palette.orange.darkAccent,
    statusBackground: `${MiTHEME.palette.orange.darkAccent}2A`,
    background: MiTHEME.palette.orange.light,
    cardBackground: MiTHEME.palette.orange.light,
  },
  [ATTEMPT_DERIVED_STATUS.ON_HOLD]: {
    main: MiTHEME.palette.purple.dark,
    title: MiTHEME.palette.purple.darkAccent,
    statusBackground: `${MiTHEME.palette.purple.dark}2A`,
    background: `${MiTHEME.palette.purple.dark}1A`,
    cardBackground: MiTHEME.palette.purple.light,
  },
  [ATTEMPT_DERIVED_STATUS.PENDING_CLOSEOUT]: {
    main: MiTHEME.palette.grey.main,
    title: MiTHEME.palette.grey.dark,
    statusBackground: `${MiTHEME.palette.grey.main}2A`,
    background: `${MiTHEME.palette.grey.main}1A`,
    cardBackground: MiTHEME.palette.grey.lightAccent,
  },
  [ATTEMPT_DERIVED_STATUS.CLOSEOUT_CLOSED]: {
    main: MiTHEME.palette.green.main,
    title: MiTHEME.palette.green.main,
    statusBackground: `${MiTHEME.palette.green.main}2A`,
    background: MiTHEME.palette.common.white,
    cardBackground: MiTHEME.palette.green.light,
  },
  [ATTEMPT_DERIVED_STATUS.PENDING_PREBILL]: {
    main: MiTHEME.palette.yellow.main,
    title: MiTHEME.palette.caution.dark,
    statusBackground: `${MiTHEME.palette.yellow.main}2A`,
    background: `${MiTHEME.palette.yellow.main}1A`,
    submittedStatusCardBackground: {
      [SUBMIT_STATUSES.COMPLETE]: MiTHEME.palette.green.light,
      [SUBMIT_STATUSES.INCOMPLETE]: MiTHEME.palette.red.light,
      [SUBMIT_STATUSES.UNABLE_TO_START]: MiTHEME.palette.red.light,
    },
  },
  [ATTEMPT_DERIVED_STATUS.PENDING_INVOICING]: {
    main: MiTHEME.palette.yellow.main,
    title: MiTHEME.palette.caution.dark,
    statusBackground: `${MiTHEME.palette.yellow.main}2A`,
    background: `${MiTHEME.palette.yellow.main}1A`,
    submittedStatusCardBackground: {
      [SUBMIT_STATUSES.COMPLETE]: MiTHEME.palette.green.light,
      [SUBMIT_STATUSES.INCOMPLETE]: MiTHEME.palette.red.light,
      [SUBMIT_STATUSES.UNABLE_TO_START]: MiTHEME.palette.red.light,
    },
  },
  [ATTEMPT_DERIVED_STATUS.CANCELLED]: {
    main: MiTHEME.palette.red.accent,
    title: MiTHEME.palette.red.dark,
    statusBackground: `${MiTHEME.palette.red.accent}2A`,
    background: MiTHEME.palette.red.light,
    cardBackground: MiTHEME.palette.red.light,
  },
  [ATTEMPT_DERIVED_STATUS.UNABLE_TO_START]: {
    main: MiTHEME.palette.red.accent,
    title: MiTHEME.palette.red.dark,
    statusBackground: `${MiTHEME.palette.red.accent}2A`,
    background: MiTHEME.palette.red.light,
    cardBackground: MiTHEME.palette.red.light,
  },
};
